import React from 'react';
import { Product } from '../types/Product';
import { FaTiktok } from 'react-icons/fa';

interface ProductCardProps {
  product: Product;
  region: 'US' | 'CA' | 'OTHER';
}

const ProductCard: React.FC<ProductCardProps> = ({ product, region }) => {
  const amazonLink = region === 'CA' ? product.amazonLinks.canada : product.amazonLinks.us;

  return (
    <div className="group relative overflow-hidden rounded-xl bg-dark-secondary transition-all duration-300 hover:scale-[1.02] hover:shadow-neon">
      <div className="aspect-w-16 aspect-h-9 relative overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
        {product.tiktokLink && (
          <a
            href={product.tiktokLink}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute right-2 top-2 rounded-full bg-black/50 p-2 text-dark-accent-pink transition-colors hover:bg-dark-accent-pink hover:text-white"
            aria-label="Watch on TikTok"
          >
            <FaTiktok size={20} />
          </a>
        )}
      </div>
      
      <div className="p-4">
        <h3 className="mb-2 text-lg font-semibold text-white">{product.name}</h3>
        <p className="mb-4 text-sm text-dark-text-secondary">{product.description}</p>
        
        <a
          href={amazonLink}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="inline-block w-full rounded-lg bg-gradient-to-r from-gradient-start to-gradient-end px-4 py-2 text-center text-white transition-shadow hover:shadow-neon-hover"
        >
          View on Amazon {region === 'CA' ? 'Canada' : 'US'}
        </a>
      </div>
    </div>
  );
};

export default ProductCard; 